module.exports = __webpack_public_path__ + "img/team-4.aee621f4.jpg";